import React from 'react';
import { Chart } from './Chart';
import { HoverInfo } from '../HoverInfo';

export function HorizontalBoxChart(props) {
    return <HoverInfo><Chart {...props} /></HoverInfo>
}
